export default __webpack_public_path__ + "static/media/grafema_tour-guide-cale-do-oiro_07.e337d39b.jpg";